import * as React from 'react';

import { NewReviewModalRating } from '../../../components/NewReviewModal';
import { GeneralRatingContainer } from './GeneralRatingContainer';
import { EcologyRatingContainer } from './EcologyRatingContainer';
import { TransportRatingContainer } from './TransportRatingContainer';
import { InfrastructureRatingContainer } from './InfrastructureRatingContainer';
import { PriceAndQualityBalanceRatingContainer } from './PriceAndQualityBalanceRatingContainer';
import { AnnouncementContainer } from './AnnouncementContainer';

export function RatingsContainer(): React.JSX.Element {
  return (
    <NewReviewModalRating>
      <AnnouncementContainer />
      <GeneralRatingContainer />
      <TransportRatingContainer />
      <InfrastructureRatingContainer />
      <EcologyRatingContainer />
      <PriceAndQualityBalanceRatingContainer />
    </NewReviewModalRating>
  );
}
